import React from 'react';
import { PinGateMode, usePinGate } from '../hooks/usePinGate';
import { PinGate } from './PinGate';
interface PinGateBoundaryProps {
  mode: PinGateMode;
  children: React.ReactNode;
}

/** Keeps every commission screen hidden until the PIN gate is passed. */
export function PinGateBoundary({
  mode,
  children
}: PinGateBoundaryProps) {
  const gate = usePinGate(mode);
  return <div className="min-h-screen w-full bg-slate-50" data-id="element-439" data-mp="rurgetvmq53g">
      <PinGate gate={gate} data-id="element-440" data-mp="rvkopza8l2np" />
      {gate.unlocked ? children : null}
    </div>;
}